import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'button[ngPrint]',
})
export class NgPrintDirective {
  /**
   * @memberof NgPrintDirective
   */
  @Input() printSectionId: string;
  /**
   * @memberof NgPrintDirective
   */
  @Input() printTitle: string;
  /**
   * @memberof NgPrintDirective
   */
  @Input() useExistingCss = false;
  /**
   * A delay in milliseconds to force the print dialog to wait before opened. Default: 500
   * @memberof NgPrintDirective
   */
  @Input() printDelay = 500;

  public _printStyle = [];

  /**
   * @memberof NgPrintDirective
   */
  @Input()
  set printStyle(values: { [key: string]: { [key: string]: string } }) {
    for (const key in values) {
      if (Object.prototype.hasOwnProperty.call(values, key)) {
        this._printStyle.push((key + JSON.stringify(values[key])).replace(/['"]+/g, ''));
      }
    }
    this.returnStyleValues();
  }

  /**
   * @returns html for the given tag
   * @memberof NgPrintDirective
   */
  private _styleSheetFile = '';

  /**
   * @memberof NgPrintDirective
   * @param cssList
   */
  @Input()
  set styleSheetFile(cssList: string) {
    const linkTagFn = cssFileName => `<link rel="stylesheet" type="text/css" href="${cssFileName}">`;
    if (cssList.indexOf(',') !== -1) {
      const valueArr = cssList.split(',');
      for (const val of valueArr) {
        this._styleSheetFile = this._styleSheetFile + linkTagFn(val);
      }
    } else {
      this._styleSheetFile = linkTagFn(cssList);
    }
  }

  /**
   * @returns the string that create the stylesheet which will be injected
   * later within <style></style> tag.
   *
   * -join/replace to transform an array objects to css-styled string
   *
   * @memberof NgPrintDirective
   */
  public returnStyleValues() {
    return `<style> ${this._printStyle.join(' ').replace(/,/g, ';')} </style>`;
  }

  /**
   * @memberof NgPrintDirective
   */
  @HostListener('click')
  public print(): void {
    setTimeout(() => {
      let styles = '',
        links = '';
      const baseTag = this.getElementTag('base');
      if (this.useExistingCss) {
        styles = this.getElementTag('style');
        links = this.getElementTag('link');
      }
      const printContents = document.getElementById(this.printSectionId).innerHTML;
      const popupWin = window.open('', '_blank', 'top=0,left=0,height=auto,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
      <html>
        <head>
          <title>${this.printTitle ? this.printTitle : ''}</title>
          ${baseTag}
          ${this.returnStyleValues()}
          ${this.returnStyleSheetLinkTags()}
          ${styles}
          ${links}
          <script async src="/assets/mathjax/tex-mml-chtml.js"></script>
          <style>
            table {
             page-break-inside: avoid;
           }
          </style>
        </head>
        <body>
          ${printContents}
          <script defer>
            function triggerPrint(event) {
              window.removeEventListener('load', triggerPrint, false);
              setTimeout(() => {
                window.print();
                setTimeout(function() { window.close(); }, 0);
              }, ${this.printDelay});
            }
            window.addEventListener('load', triggerPrint, false);
          </script>
        </body>
      </html>`);

      popupWin.document.close();
    }, 1000);
  }

  /**
   * @returns string which contains the link tags containing the css which will
   * be injected later within <head></head> tag.
   */
  private returnStyleSheetLinkTags(): string {
    return this._styleSheetFile;
  }

  private getElementTag(tag: keyof HTMLElementTagNameMap): string {
    const html: string[] = [];
    const elements = document.getElementsByTagName(tag);
    for (let index = 0; index < elements.length; index++) {
      html.push(elements[index].outerHTML);
    }
    return html.join('\r\n');
  }
}
